//JIRA LPPLWEBMOB-563
import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store";

import { FormDataInputs } from "./summary.slice";

export const selectFormData = (store: RootState): FormDataInputs =>
  store.ac.summary;

export const selectAgreeDecisionEmail = createSelector(
  selectFormData,
  (state) => state.AgreeDecisionEmail
);

export const selectAgreeRentinVehicleEmail = createSelector(
  selectFormData,
  (state) => state.AgreeRentinVehicleEmail
);

export const selectAgreeContactEmail = createSelector(
  selectFormData,
  (state) => state.AgreeContactEmail
);
